import { render, staticRenderFns } from "./tradeRejected.vue?vue&type=template&id=86ca8648&scoped=true&"
import script from "./tradeRejected.vue?vue&type=script&lang=ts&"
export * from "./tradeRejected.vue?vue&type=script&lang=ts&"
import style0 from "./tradeRejected.vue?vue&type=style&index=0&id=86ca8648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ca8648",
  null
  
)

export default component.exports